import { Injectable } from "@angular/core";
import { ApiServiceService } from "../../../services/api-service.service";
import { environment } from "../../../../environments/environment";
import { catchError, throwError } from "rxjs";
import { formatParams } from "../../../helpers/FormateArrayToParams";

@Injectable({
    providedIn: 'root'
})
export class CompanyProfileService {

    constructor(private apiService: ApiServiceService) { }

    CompanyProfileDetails(company_id: any) {
        return this.apiService.get(`${environment.apiUrl}/company-profile?company_id=${company_id}`)
            .pipe(catchError(this.handleError));
    }

    getSubscriptions(filterModel: any): any {
        return this.apiService.get(`${environment.apiUrl}/company-profile/subscriptions`, filterModel)
            .pipe(catchError(this.handleError));
    }

    getEmployees(filterModel: any): any {
        let Params = formatParams(filterModel)
        return this.apiService.get(`${environment.apiUrl}/company-profile/emplyees${Params}`)
            .pipe(catchError(this.handleError));
    }

    getDepartments(filterModel: any): any {
        return this.apiService.get(`${environment.apiUrl}/company-profile/departments`, filterModel)
            .pipe(catchError(this.handleError));
    }

    getRewardedPoints(filterModel: any): any {
        return this.apiService.get(`${environment.apiUrl}/company-profile/rewarding-points`, filterModel)
            .pipe(catchError(this.handleError));
    }

    suspendUnSuspendCompany(id: any, type: any) {
        // Type = suspend unsuspend
        return this.apiService.post(`${environment.apiUrl}/company-profile/${type}/${id}`)
            .pipe(catchError(this.handleError));
    }

    ResendVerificationCompany(id: string) {
        return this.apiService.post(`${environment.apiUrl}/resend-verification-company/${id}`)
            .pipe(catchError(this.handleError));
    }

    deleteCompany(id: any) {
        return this.apiService.remove(`${environment.apiUrl}/companies/${id}`)
            .pipe(catchError(this.handleError));
    }

    enableDisableHrService(data: any) {
        return this.apiService.post(`${environment.apiUrl}/companies/toggle-hr-service`, data)
            .pipe(catchError(this.handleError));
    }

    getHrServices(id: string) {
        return this.apiService.get(`${environment.apiUrl}/companies/services?company_id=${id}`)
            .pipe(catchError(this.handleError));
    }

    ChangeOnCompanyServices(data: any) {
        return this.apiService.post(`${environment.apiUrl}/companies/services`, data)
            .pipe(catchError(this.handleError));
    }

    getDepartmentsBasedOnRole(filterModel: any): any {
        return this.apiService.get(`${environment.apiUrl}/company-profile/departments-depend-on-role-for-attendance`, filterModel)
            .pipe(catchError(this.handleError));
    }

    handleError(error: any) {
        return throwError(error);
    }
}